import { useContext } from 'react';
import { MainContext } from './main-context';
export function useMainContext() {
    var contextValues = useContext(MainContext);
    if (!contextValues) {
        throw new Error('used outside the context provider useMainContext');
    }
    return contextValues;
}
